import React from 'react';
import PropTypes from 'prop-types';
import {Utilities} from '@learningblocks/exp-constants';
const {DESIGN} = Utilities;

import {Wrapper} from './Wrapper';

/**
 * GroupA:
 *  - Group is reponsible for displaying the following NODE_TYPE: [ START_NODE, END_NODE, JOINT_NODE ]
 *  - Used in DesignViewOne, DesignViewTwo, DesignViewThree, DesignViewFour
 */
export function GroupA(props) {
  const startNode = (n) => {
    return React.cloneElement(props.startNode, {
      ...props.startNode.props,
      key: n.nodeId,
      nodeComponents: n.nodeComponents,
    });
  };

  const onDropStep = React.useCallback((params) => {
    props.onDropStep({...params, groupId: props.groupId});
  }, []);

  const onRemoveStep = React.useCallback((params) => {
    props.onRemoveStep({...params, groupId: props.groupId});
  }, []);

  const jointNode = (node) => {
    return React.cloneElement(props.jointNode, {
      ...props.jointNode.props,
      key: node.nodeId,
      nodeId: node.nodeId,
      onDropStep: onDropStep,
      onRemoveStep: onRemoveStep,
      nodeComponents: node.nodeComponents,
    });
  };

  const endNode = (n) => {
    return React.cloneElement(props.endNode, {
      ...props.endNode.props,
      key: n.nodeId,
      nodeComponents: n.nodeComponents,
    });
  };

  const renderNodeByType = (n) => {
    switch (n.nodeType) {
      case DESIGN.NODE.START:
        return startNode(n);
      case DESIGN.NODE.JOINT:
        return jointNode(n);
      case DESIGN.NODE.END:
        return endNode(n);
      default:
        return <div> {n.nodeType} not ready yet</div>;
    }
  };

  return (
    <Wrapper className={props.className}>
      {props.groupNodes.map(renderNodeByType)}
    </Wrapper>
  );
}

GroupA.propTypes = {
  /**
   * group Id
   */
  groupId: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * List of nodes to display in Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Node
       */
      nodeId: PropTypes.number,
      /**
       * Type of Node
       */
      nodeType: PropTypes.oneOf(['START_NODE', 'JOINT_NODE', 'END_NODE']),
      /**
       * List of components to display on Node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
    })
  ),
  /**
   * Component to use for type START_NODE
   */
  startNode: PropTypes.node,
  /**
   * Component to use for type JOINT_NODE
   */
  jointNode: PropTypes.node,
  /**
   * Component to user for type END_NODE
   */
  endNode: PropTypes.node,
};

GroupA.defaultProps = {
  className: '',
};
